import angular from 'angular';
import '../core/data/invoice/invoice-filter.data.js';

(function() {
  'use strict';
  angular.module('app.docrepo_invoice').factory('DocrepoInvoicesSvc', DocrepoInvoicesSvc);

  DocrepoInvoicesSvc.$inject = ['KissInvoiceDA', 'InvoiceFilter'];

  function DocrepoInvoicesSvc(KissInvoiceDA, InvoiceFilter) {
    var exports = {
      searchInvoices: searchInvoices,
      searchInvoiceByGuid: searchInvoiceByGuid,
      createFilter: createFilter,
      getDocumentJson: getDocumentJson,
      getDocumentEvents: getDocumentEvents
    };

    return exports;

    ////////////////

    /**
     * Recherche des factures sur la docrepo suivant des critères
     * @param filter Critères de recherches
     */
    function searchInvoices(filter) {
      return KissInvoiceDA.searchInvoices(filter);
    }

    /**
     * Créé le filtre de recherche de factures.
     */
    function createFilter(criterias, gridParams) {
      var filter = new InvoiceFilter();
      filter.setPageSize(gridParams.paginationPageSize);
      filter.setPage(gridParams.page);
      if (gridParams.sorts) {
        filter.setSorts(gridParams.sorts);
      }
      if (criterias.guid) {
        filter.setGuid(criterias.guid);
      }
      if (criterias.seller) {
        filter.setSender(criterias.seller);
      }
      if (criterias.buyer) {
        filter.setBuyer(criterias.buyer.id, criterias.buyer.perimeters);
      }
      filter.setPrincipalId(criterias.principalId);
      if (criterias.invoiceNumber) {
        filter.setDocumentNumber([criterias.invoiceNumber]);
      }
      filter.setCreationDateFrom(criterias.creationDateFrom);
      filter.setCreationDateTo(criterias.creationDateTo);
      if (criterias.invoiceStatus) {
        filter.setStatus([criterias.invoiceStatus.toUpperCase()]);
      }
      if (criterias.orderNumber) {
        filter.setOrderRefs([criterias.orderNumber]);
      }
      return filter;
    }

    /**
     * Recherche une facture à partir de son guid.
     * @param guid de la facture
     */
    function searchInvoiceByGuid(guid, loadOptions) {
      var filter = new InvoiceFilter();
      filter.setGuid(guid);
      filter.setDocumentOptions(loadOptions);
      return KissInvoiceDA.searchInvoices(filter);
    }

    /**
     * Fournit le Json complet d'une facture.
     * @param guid Guid du document docrepo
     */
    function getDocumentJson(guid) {
      return KissInvoiceDA.getDocumentJson(guid);
    }

    /**
     * Fournit les évènements de la facture.
     * @param guid Guid du document docrepo
     */
    function getDocumentEvents(guid) {
      return KissInvoiceDA.getDocumentEvents(guid);
    }
  }
})();
